/**
 * Réglages des offres (migration 0717) : durées de pass proposées, essai
 * gratuit des abonnements mensuels (et le droit du compte connecté), promo
 * SKILLCARDS en cours. Lecture publique `get_offer_settings()`.
 */
import { useQuery } from '@tanstack/react-query';
import type { SupabaseClient } from '@supabase/supabase-js';
import {
  DEFAULT_OFFER_SETTINGS,
  parseOfferSettings,
  type OfferSettings,
} from '@jeraisonne/db/offers';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/lib/auth';

const db = supabase as unknown as SupabaseClient;

export async function fetchOfferSettings(): Promise<OfferSettings> {
  const { data, error } = await db.rpc('get_offer_settings');
  if (error) throw new Error(error.message);
  return parseOfferSettings(data);
}

/** Réglages des offres ; valeurs par défaut tant qu'ils ne sont pas chargés. */
export function useOfferSettings(): OfferSettings {
  const { session } = useAuth();
  const q = useQuery({
    // l'éligibilité à l'essai dépend du compte connecté
    queryKey: ['offer-settings', session?.user?.id ?? null],
    queryFn: fetchOfferSettings,
    staleTime: 60_000,
  });
  return q.data ?? DEFAULT_OFFER_SETTINGS;
}
